module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name
    }
  }, [_c('div', {
    staticClass: "bar-wrap"
  }, [_c('ul', {
    staticClass: "list",
    attrs: {
      "id": "list"
    }
  }, _vm._l((_vm.list), function(item, index) {
    var _obj;

    return _c('li', {
      key: index,
      class: [( _obj = {}, _obj['active'] = item.flag, _obj )]
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "lines"
  }, [(_vm.num % 2 === 0) ? _c('div', {
    staticClass: "main"
  }) : _c('div', {
    staticClass: "main1"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d88697ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/trace/line/index.vue
// module id = 2091
// module chunks = 2